import { TFunction } from "i18next";
import {
	ElectricityIcon,
	FridgeIcon,
	FuelIcon,
	HeatSteamIcon,
	ProcessGasIcon,
	WaterIcon,
} from "../../../../../../assets/icons";
import { DataChart } from "../../../../../../components/charts/graph/PieChartDistributionType";
import { SitesEmissionsBySource } from "../../../../../../datasources/api-client/data-contracts";
import { EmissionsTypesColors } from "../../../../../../theme/themeValues";

export const typesDataEmissions = (t: TFunction) =>
	({
		electricity: {
			label: t("greenrouter/consumption emission/electricity"),
			icon: <ElectricityIcon sx={{ color: EmissionsTypesColors.LightElectricity }} />,
		},
		fuels: {
			label: t("greenrouter/consumption emission/fuel"),
			icon: <FuelIcon sx={{ color: EmissionsTypesColors.LightFuel }} />,
		},
		refrigerants: {
			label: t("greenrouter/consumption emission/refrigerants"),
			icon: <FridgeIcon sx={{ color: EmissionsTypesColors.LightRefrigerant }} />,
		},
		processGas: {
			label: t("greenrouter/consumption emission/processGas"),
			icon: <ProcessGasIcon sx={{ color: EmissionsTypesColors.LightProcessGases }} />,
		},
		heatSteam: {
			label: t("greenrouter/consumption emission/heatSteam"),
			icon: <HeatSteamIcon sx={{ color: EmissionsTypesColors.LightHeat }} />,
		},
		water: {
			label: t("greenrouter/consumption emission/water"),
			icon: <WaterIcon sx={{ color: EmissionsTypesColors.LightWater }} />,
		},
	}) as const;

export type ModeKey = keyof ReturnType<typeof typesDataEmissions>;

export type EmissionDataKey = keyof SitesEmissionsBySource;

export const getDataChart = (data: SitesEmissionsBySource, t: TFunction): DataChart[] => {
	const metaData = typesDataEmissions(t);

	return (
		Object.entries(data)
			.filter(([key]) => key !== "total")
			.map(([key, value]) => {
				const meta = metaData[key as ModeKey];

				return {
					id: key,
					percent: value.co2e ? Number(value.co2e.percentage.toFixed(2)) : 0,
					value: value.co2e?.value ?? 0,
					label: meta.label,
					icon: meta.icon,
				};
			}) || []
	);
};
